"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var phone_svg_1 = __importDefault(require("../../../../../../../images/post-preview/phone.svg"));
var email_svg_1 = __importDefault(require("../../../../../../../images/post-preview/email.svg"));
var website_svg_1 = __importDefault(require("../../../../../../../images/post-preview/website.svg"));
var phoneNumberHelper_1 = require("../../../../../../helpers/phoneNumberHelper");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ContactUs = function (_a) {
    var phone = _a.phone, email = _a.email, website = _a.website;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_box },
        phone && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("img", { src: phone_svg_1.default, alt: "../" }),
            react_1.default.createElement("p", null, phoneNumberHelper_1.formatPhoneNumber(phone)))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("img", { src: email_svg_1.default, alt: "../" }),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.email }, email)),
        website && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("img", { src: website_svg_1.default, alt: "../" }),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.website }, website)))));
};
exports.default = ContactUs;
